import { useContext, useLayoutEffect } from 'react'
import { PageLoadingContext } from '../index'

export default function PageLoading() {
  const [, setPageLoading] = useContext(PageLoadingContext)

  useLayoutEffect(() => {
    setPageLoading(true)
    return () => {
      setPageLoading(false)
    }
  }, [setPageLoading])
  return null
}
